export default __webpack_public_path__ + "static/img66h-11a75eeeb91b641fdc9f4e042968ddec.jpg";